var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "VISA_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 40"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".VISA_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#1334cb}")), /*#__PURE__*/React.createElement("path", {
    d: "M3.2 39.5c-1.5 0-2.7-1.3-2.7-2.8V3.3C.5 1.7 1.7.5 3.2.5h57.6c1.5 0 2.7 1.3 2.7 2.8v33.3c0 1.6-1.2 2.8-2.7 2.8H3.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8 1C62 1 63 2 63 3.3v33.3c0 1.3-1 2.3-2.2 2.3H3.2C2 39 1 38 1 36.7V3.3C1 2 2 1 3.2 1zm0-1H3.2C1.4 0 0 1.5 0 3.3v33.3C0 38.5 1.4 40 3.2 40h57.6c1.8 0 3.2-1.5 3.2-3.3V3.3C64 1.5 62.6 0 60.8 0",
    style: {
      fill: "#ddd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8 17c0 2.3 2 3.7 3.7 4.3 1.7.8 2.2 1.3 2.2 2 0 1-1.3 1.5-2.5 1.5-2 0-3.3-.5-4.2-1l-.7 3.5c1 .5 2.8.8 4.7.8 4.3 0 7.2-2.2 7.2-5.5 0-4.2-5.8-4.5-5.8-6.3 0-.5.5-1.2 1.8-1.3.7 0 2.2-.2 4 .7l.7-3.3c-1.2-.3-2.3-.7-4-.7-4.1 0-7.1 2.1-7.1 5.3M54.3 12h-3.5c-.8 0-1.5.5-1.8 1.2L42.8 28h4.3l.8-2.3h5.3l.5 2.3h3.8zm-5.1 10.3 2.2-6 1.3 6zM27.7 12l-3.5 16h4.1l3.5-16zM21.5 12l-4.3 10.8-1.7-9.3c-.2-1-1-1.7-1.8-1.7H6.5l-.2.7c1.5.3 3.2.8 4.2 1.3.7.3.8.7 1 1.3L14.8 28h4.3l6.7-16z",
    className: "VISA_svg__st2"
  })));
};
export default SvgVisa;